import { BlockKeys } from '@data/Simulations/pipeline/BlockCatalog';

export const DEVELOPMENT_BLOCK_TYPES = new Set<string>([BlockKeys.PvPotentials, BlockKeys.ShgPotentials]);
